  <template>
  <v-container fluid grid-list-sm>
    <v-tabs
      grow
      color="grey6"
      v-model="tab"
      slider-color="primary"
      active-class="v-tabs__item--active primary cr-team-shadow white--text"
    >
      <v-tab href="#accounts" class="font-weight-bold subtitle-2">{{
        customer.name
      }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item value="accounts">
        <v-layout row wrap>
          <v-flex xs12 class="mb-3 px-0 pb-0">
            <v-item-group v-model="toggle_exclusive" mandatory>
              <v-container grid-list-xs fluid class="white shadow">
                <v-layout row wrap justify-center v-if="accounts.length == 0">
                  <div class="py-3">{{$t('no_transaction_found')}}</div>
                </v-layout>
                <v-layout wrap align-start v-if="accounts.length > 0">
                  <v-item :key="item.id" v-for="item in accounts">
                    <v-btn
                      outline
                      slot-scope="{ active, toggle }"
                      :color="active ? 'primary' : ''"
                      @click="getTransactions(item, toggle)"
                      :class="
                        active
                          ? 'tile_btn border  flex xs12 sm3 md2 shadow-md'
                          : 'tile_btn border flex xs12 sm3 md2'
                      "
                    >
                      <v-scroll-y-transition>
                        <div class="flex-column">
                          <strong
                            :class="
                              active
                                ? 'headline font-weight-medium'
                                : 'headline font-weight-medium grey--text'
                            "
                            >{{ item.balance | currency }}</strong
                          >
                          <span
                            :class="{ 'text--darken-3': active }"
                            class="grey--text mt-2"
                          >
                            <span> {{ `${item.name}` }} - </span>
                            <span> {{ getRate(item.currency_id) }}</span>
                          </span>
                        </div>
                      </v-scroll-y-transition>
                    </v-btn>
                  </v-item>
                </v-layout>
              </v-container>
            </v-item-group>
          </v-flex>

          <branch-account-view
            ref="acView"
            @update="initData"
            v-bind="{ customer, account }"
            v-if="customer.type == 'branch' && accounts.length > 0"
          />
          <account-view
            ref="acView"
            @update="initData"
            v-bind="{ customer, account }"
            v-if="customer.type != 'branch' && accounts.length > 0"
          />
        </v-layout>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import accountView from "./profile/accountView";
import { customersMixin } from "@/mixins/index.js";
import branchAccountView from "./profile/branchAccountView";

export default {
  props: {
    system: { default: false },
    DailyProfit: { default: false },
    stock: { default: false },
  },

  mixins: [customersMixin],

  components: {
    accountView,
    branchAccountView,
  },

  data: () => ({
    accounts: [],
    dialog: false,
    tab: "accounts",
    toggle_exclusive: 0,

    customer: {
      id: "",
      address: "",
      name: "",
      type: "customer",
      account_number: "",
    },

    account: {
      id: null,
      balance: 0,
      name: null,
      type: "cash",
      customer_id: null,
      currency_id: null,
      currency: { rank: "", name: "" },
    },
  }),

  methods: {
    getRate(currency_id) {
      let c = this.initialData.mapped_currencies[currency_id] || { rate: 1 };
      return c.rate;
    },
    getTransactions(account, toggle) {
      this.account = account;
      toggle();
    },

    initData() {
      let id = this.$store.state.route.params.id;
      let type = this.$store.state.route.query.type;
      this.axios
        .get(
          `customers/${id}?type=${type}&system=${this.system}&DailyProfit=${this.DailyProfit}&stock=${this.stock}`
        )
        .then((res) => {
          let accounts = res.data.data.accounts.filter(
            (x) => x.type != "unknown_source"
          );

          this.accounts = accounts;
          this.customer = res.data.data;
          this.account.customer_id = this.customer.id;
          if (accounts.length > 0) {
            this.account = accounts[0];
            // this.$refs.acView.getTransactions(this.account);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  computed: {
    agency() {
      return this.customer.type == "branch";
    },
  },

  created() {
    this.initData();
    this.getCustomers();
  },
  watch: {
    $route: {
      handler() {
        this.initData();
      },
      deep: true,
    },
  },
};
</script>
<style>
.tile_btn {
  height: 100px;
}
.tile_btn:hover {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1) !important;
}
</style>